/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as StartRouteImport } from './routes/start'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedChildrenRouteRouteImport } from './routes/_protected/children/route'
import { Route as ProtectedExamRouteImport } from './routes/_protected/exam'
import { Route as ProtectedNewsRouteImport } from './routes/_protected/news'
import { Route as ProtectedNotificationsRouteImport } from './routes/_protected/notifications'
import { Route as ProtectedPaywallRouteImport } from './routes/_protected/paywall'
import { Route as ProtectedPracticeRouteImport } from './routes/_protected/practice'
import { Route as ProtectedProfileRouteImport } from './routes/_protected/profile'
import { Route as ProtectedChildrenIndexRouteImport } from './routes/_protected/children/index'
import { Route as ProtectedOnboardingDetailsRouteImport } from './routes/_protected/onboarding/details'
import { Route as ProtectedOnboardingPlansRouteImport } from './routes/_protected/onboarding/plans'
import { Route as ProtectedSummaryLinkIdRouteImport } from './routes/_protected/summary/$linkId'
import { Route as ProtectedChildrenLinkIdIndexRouteImport } from './routes/_protected/children/$linkId/index'
import { Route as ProtectedChildrenLinkIdActivityRouteImport } from './routes/_protected/children/$linkId/activity'
import { Route as ProtectedChildrenLinkIdHomeworkIndexRouteImport } from './routes/_protected/children/$linkId/homework/index'
import { Route as ProtectedChildrenLinkIdHomeworkAssignmentIdRouteImport } from './routes/_protected/children/$linkId/homework/$assignmentId'
import { Route as ProtectedChildrenLinkIdReportsIndexRouteImport } from './routes/_protected/children/$linkId/reports/index'
import { Route as ProtectedChildrenLinkIdReportsReportIdRouteImport } from './routes/_protected/children/$linkId/reports/$reportId'

const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedChildrenRouteRoute = ProtectedChildrenRouteRouteImport.update({
  id: '/children',
  path: '/children',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedExamRoute = ProtectedExamRouteImport.update({
  id: '/exam',
  path: '/exam',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedNewsRoute = ProtectedNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedNotificationsRoute = ProtectedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedPaywallRoute = ProtectedPaywallRouteImport.update({
  id: '/paywall',
  path: '/paywall',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedPracticeRoute = ProtectedPracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedChildrenIndexRoute = ProtectedChildrenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedChildrenRouteRoute,
} as any)
const ProtectedOnboardingDetailsRoute =
  ProtectedOnboardingDetailsRouteImport.update({
    id: '/onboarding/details',
    path: '/onboarding/details',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedOnboardingPlansRoute =
  ProtectedOnboardingPlansRouteImport.update({
    id: '/onboarding/plans',
    path: '/onboarding/plans',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSummaryLinkIdRoute = ProtectedSummaryLinkIdRouteImport.update({
  id: '/summary/$linkId',
  path: '/summary/$linkId',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedChildrenLinkIdIndexRoute =
  ProtectedChildrenLinkIdIndexRouteImport.update({
    id: '/$linkId/',
    path: '/$linkId/',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)
const ProtectedChildrenLinkIdActivityRoute =
  ProtectedChildrenLinkIdActivityRouteImport.update({
    id: '/$linkId/activity',
    path: '/$linkId/activity',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)
const ProtectedChildrenLinkIdHomeworkIndexRoute =
  ProtectedChildrenLinkIdHomeworkIndexRouteImport.update({
    id: '/$linkId/homework/',
    path: '/$linkId/homework/',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)
const ProtectedChildrenLinkIdHomeworkAssignmentIdRoute =
  ProtectedChildrenLinkIdHomeworkAssignmentIdRouteImport.update({
    id: '/$linkId/homework/$assignmentId',
    path: '/$linkId/homework/$assignmentId',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)
const ProtectedChildrenLinkIdReportsIndexRoute =
  ProtectedChildrenLinkIdReportsIndexRouteImport.update({
    id: '/$linkId/reports/',
    path: '/$linkId/reports/',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)
const ProtectedChildrenLinkIdReportsReportIdRoute =
  ProtectedChildrenLinkIdReportsReportIdRouteImport.update({
    id: '/$linkId/reports/$reportId',
    path: '/$linkId/reports/$reportId',
    getParentRoute: () => ProtectedChildrenRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/verify-email': typeof VerifyEmailRoute
  '/welcome': typeof WelcomeRoute
  '/children': typeof ProtectedChildrenRouteRouteWithChildren
  '/exam': typeof ProtectedExamRoute
  '/news': typeof ProtectedNewsRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/paywall': typeof ProtectedPaywallRoute
  '/practice': typeof ProtectedPracticeRoute
  '/profile': typeof ProtectedProfileRoute
  '/onboarding/details': typeof ProtectedOnboardingDetailsRoute
  '/onboarding/plans': typeof ProtectedOnboardingPlansRoute
  '/summary/$linkId': typeof ProtectedSummaryLinkIdRoute
  '/children/': typeof ProtectedChildrenIndexRoute
  '/children/$linkId/activity': typeof ProtectedChildrenLinkIdActivityRoute
  '/children/$linkId/': typeof ProtectedChildrenLinkIdIndexRoute
  '/children/$linkId/homework/$assignmentId': typeof ProtectedChildrenLinkIdHomeworkAssignmentIdRoute
  '/children/$linkId/reports/$reportId': typeof ProtectedChildrenLinkIdReportsReportIdRoute
  '/children/$linkId/homework/': typeof ProtectedChildrenLinkIdHomeworkIndexRoute
  '/children/$linkId/reports/': typeof ProtectedChildrenLinkIdReportsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/verify-email': typeof VerifyEmailRoute
  '/welcome': typeof WelcomeRoute
  '/exam': typeof ProtectedExamRoute
  '/news': typeof ProtectedNewsRoute
  '/notifications': typeof ProtectedNotificationsRoute
  '/paywall': typeof ProtectedPaywallRoute
  '/practice': typeof ProtectedPracticeRoute
  '/profile': typeof ProtectedProfileRoute
  '/': typeof ProtectedIndexRoute
  '/onboarding/details': typeof ProtectedOnboardingDetailsRoute
  '/onboarding/plans': typeof ProtectedOnboardingPlansRoute
  '/summary/$linkId': typeof ProtectedSummaryLinkIdRoute
  '/children': typeof ProtectedChildrenIndexRoute
  '/children/$linkId/activity': typeof ProtectedChildrenLinkIdActivityRoute
  '/children/$linkId': typeof ProtectedChildrenLinkIdIndexRoute
  '/children/$linkId/homework/$assignmentId': typeof ProtectedChildrenLinkIdHomeworkAssignmentIdRoute
  '/children/$linkId/reports/$reportId': typeof ProtectedChildrenLinkIdReportsReportIdRoute
  '/children/$linkId/homework': typeof ProtectedChildrenLinkIdHomeworkIndexRoute
  '/children/$linkId/reports': typeof ProtectedChildrenLinkIdReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/verify-email': typeof VerifyEmailRoute
  '/welcome': typeof WelcomeRoute
  '/_protected/children': typeof ProtectedChildrenRouteRouteWithChildren
  '/_protected/exam': typeof ProtectedExamRoute
  '/_protected/news': typeof ProtectedNewsRoute
  '/_protected/notifications': typeof ProtectedNotificationsRoute
  '/_protected/paywall': typeof ProtectedPaywallRoute
  '/_protected/practice': typeof ProtectedPracticeRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/onboarding/details': typeof ProtectedOnboardingDetailsRoute
  '/_protected/onboarding/plans': typeof ProtectedOnboardingPlansRoute
  '/_protected/summary/$linkId': typeof ProtectedSummaryLinkIdRoute
  '/_protected/children/': typeof ProtectedChildrenIndexRoute
  '/_protected/children/$linkId/activity': typeof ProtectedChildrenLinkIdActivityRoute
  '/_protected/children/$linkId/': typeof ProtectedChildrenLinkIdIndexRoute
  '/_protected/children/$linkId/homework/$assignmentId': typeof ProtectedChildrenLinkIdHomeworkAssignmentIdRoute
  '/_protected/children/$linkId/reports/$reportId': typeof ProtectedChildrenLinkIdReportsReportIdRoute
  '/_protected/children/$linkId/homework/': typeof ProtectedChildrenLinkIdHomeworkIndexRoute
  '/_protected/children/$linkId/reports/': typeof ProtectedChildrenLinkIdReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/verify-email'
    | '/welcome'
    | '/children'
    | '/exam'
    | '/news'
    | '/notifications'
    | '/paywall'
    | '/practice'
    | '/profile'
    | '/onboarding/details'
    | '/onboarding/plans'
    | '/summary/$linkId'
    | '/children/'
    | '/children/$linkId/activity'
    | '/children/$linkId/'
    | '/children/$linkId/homework/$assignmentId'
    | '/children/$linkId/reports/$reportId'
    | '/children/$linkId/homework/'
    | '/children/$linkId/reports/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/verify-email'
    | '/welcome'
    | '/exam'
    | '/news'
    | '/notifications'
    | '/paywall'
    | '/practice'
    | '/profile'
    | '/'
    | '/onboarding/details'
    | '/onboarding/plans'
    | '/summary/$linkId'
    | '/children'
    | '/children/$linkId/activity'
    | '/children/$linkId'
    | '/children/$linkId/homework/$assignmentId'
    | '/children/$linkId/reports/$reportId'
    | '/children/$linkId/homework'
    | '/children/$linkId/reports'
  id:
    | '__root__'
    | '/_protected'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/verify-email'
    | '/welcome'
    | '/_protected/children'
    | '/_protected/exam'
    | '/_protected/news'
    | '/_protected/notifications'
    | '/_protected/paywall'
    | '/_protected/practice'
    | '/_protected/profile'
    | '/_protected/'
    | '/_protected/onboarding/details'
    | '/_protected/onboarding/plans'
    | '/_protected/summary/$linkId'
    | '/_protected/children/'
    | '/_protected/children/$linkId/activity'
    | '/_protected/children/$linkId/'
    | '/_protected/children/$linkId/homework/$assignmentId'
    | '/_protected/children/$linkId/reports/$reportId'
    | '/_protected/children/$linkId/homework/'
    | '/_protected/children/$linkId/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  StartRoute: typeof StartRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/children': {
      id: '/_protected/children'
      path: '/children'
      fullPath: '/children'
      preLoaderRoute: typeof ProtectedChildrenRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/exam': {
      id: '/_protected/exam'
      path: '/exam'
      fullPath: '/exam'
      preLoaderRoute: typeof ProtectedExamRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/news': {
      id: '/_protected/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof ProtectedNewsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/notifications': {
      id: '/_protected/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof ProtectedNotificationsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/paywall': {
      id: '/_protected/paywall'
      path: '/paywall'
      fullPath: '/paywall'
      preLoaderRoute: typeof ProtectedPaywallRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/practice': {
      id: '/_protected/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof ProtectedPracticeRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/children/': {
      id: '/_protected/children/'
      path: '/'
      fullPath: '/children/'
      preLoaderRoute: typeof ProtectedChildrenIndexRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/onboarding/details': {
      id: '/_protected/onboarding/details'
      path: '/onboarding/details'
      fullPath: '/onboarding/details'
      preLoaderRoute: typeof ProtectedOnboardingDetailsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/onboarding/plans': {
      id: '/_protected/onboarding/plans'
      path: '/onboarding/plans'
      fullPath: '/onboarding/plans'
      preLoaderRoute: typeof ProtectedOnboardingPlansRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/summary/$linkId': {
      id: '/_protected/summary/$linkId'
      path: '/summary/$linkId'
      fullPath: '/summary/$linkId'
      preLoaderRoute: typeof ProtectedSummaryLinkIdRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/children/$linkId/': {
      id: '/_protected/children/$linkId/'
      path: '/$linkId'
      fullPath: '/children/$linkId/'
      preLoaderRoute: typeof ProtectedChildrenLinkIdIndexRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/children/$linkId/activity': {
      id: '/_protected/children/$linkId/activity'
      path: '/$linkId/activity'
      fullPath: '/children/$linkId/activity'
      preLoaderRoute: typeof ProtectedChildrenLinkIdActivityRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/children/$linkId/homework/': {
      id: '/_protected/children/$linkId/homework/'
      path: '/$linkId/homework'
      fullPath: '/children/$linkId/homework/'
      preLoaderRoute: typeof ProtectedChildrenLinkIdHomeworkIndexRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/children/$linkId/homework/$assignmentId': {
      id: '/_protected/children/$linkId/homework/$assignmentId'
      path: '/$linkId/homework/$assignmentId'
      fullPath: '/children/$linkId/homework/$assignmentId'
      preLoaderRoute: typeof ProtectedChildrenLinkIdHomeworkAssignmentIdRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/children/$linkId/reports/': {
      id: '/_protected/children/$linkId/reports/'
      path: '/$linkId/reports'
      fullPath: '/children/$linkId/reports/'
      preLoaderRoute: typeof ProtectedChildrenLinkIdReportsIndexRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
    '/_protected/children/$linkId/reports/$reportId': {
      id: '/_protected/children/$linkId/reports/$reportId'
      path: '/$linkId/reports/$reportId'
      fullPath: '/children/$linkId/reports/$reportId'
      preLoaderRoute: typeof ProtectedChildrenLinkIdReportsReportIdRouteImport
      parentRoute: typeof ProtectedChildrenRouteRoute
    }
  }
}

interface ProtectedChildrenRouteRouteChildren {
  ProtectedChildrenIndexRoute: typeof ProtectedChildrenIndexRoute
  ProtectedChildrenLinkIdActivityRoute: typeof ProtectedChildrenLinkIdActivityRoute
  ProtectedChildrenLinkIdIndexRoute: typeof ProtectedChildrenLinkIdIndexRoute
  ProtectedChildrenLinkIdHomeworkAssignmentIdRoute: typeof ProtectedChildrenLinkIdHomeworkAssignmentIdRoute
  ProtectedChildrenLinkIdReportsReportIdRoute: typeof ProtectedChildrenLinkIdReportsReportIdRoute
  ProtectedChildrenLinkIdHomeworkIndexRoute: typeof ProtectedChildrenLinkIdHomeworkIndexRoute
  ProtectedChildrenLinkIdReportsIndexRoute: typeof ProtectedChildrenLinkIdReportsIndexRoute
}

const ProtectedChildrenRouteRouteChildren: ProtectedChildrenRouteRouteChildren =
  {
    ProtectedChildrenIndexRoute: ProtectedChildrenIndexRoute,
    ProtectedChildrenLinkIdActivityRoute: ProtectedChildrenLinkIdActivityRoute,
    ProtectedChildrenLinkIdIndexRoute: ProtectedChildrenLinkIdIndexRoute,
    ProtectedChildrenLinkIdHomeworkAssignmentIdRoute:
      ProtectedChildrenLinkIdHomeworkAssignmentIdRoute,
    ProtectedChildrenLinkIdReportsReportIdRoute:
      ProtectedChildrenLinkIdReportsReportIdRoute,
    ProtectedChildrenLinkIdHomeworkIndexRoute:
      ProtectedChildrenLinkIdHomeworkIndexRoute,
    ProtectedChildrenLinkIdReportsIndexRoute:
      ProtectedChildrenLinkIdReportsIndexRoute,
  }

const ProtectedChildrenRouteRouteWithChildren =
  ProtectedChildrenRouteRoute._addFileChildren(
    ProtectedChildrenRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedChildrenRouteRoute: typeof ProtectedChildrenRouteRouteWithChildren
  ProtectedExamRoute: typeof ProtectedExamRoute
  ProtectedNewsRoute: typeof ProtectedNewsRoute
  ProtectedNotificationsRoute: typeof ProtectedNotificationsRoute
  ProtectedPaywallRoute: typeof ProtectedPaywallRoute
  ProtectedPracticeRoute: typeof ProtectedPracticeRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedOnboardingDetailsRoute: typeof ProtectedOnboardingDetailsRoute
  ProtectedOnboardingPlansRoute: typeof ProtectedOnboardingPlansRoute
  ProtectedSummaryLinkIdRoute: typeof ProtectedSummaryLinkIdRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedChildrenRouteRoute: ProtectedChildrenRouteRouteWithChildren,
  ProtectedExamRoute: ProtectedExamRoute,
  ProtectedNewsRoute: ProtectedNewsRoute,
  ProtectedNotificationsRoute: ProtectedNotificationsRoute,
  ProtectedPaywallRoute: ProtectedPaywallRoute,
  ProtectedPracticeRoute: ProtectedPracticeRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedOnboardingDetailsRoute: ProtectedOnboardingDetailsRoute,
  ProtectedOnboardingPlansRoute: ProtectedOnboardingPlansRoute,
  ProtectedSummaryLinkIdRoute: ProtectedSummaryLinkIdRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  StartRoute: StartRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
